import Base from 'front/components/Base/Base';

import './Animations.less';

const Selectors = {
    el: '.IndexAnimations'
};

export default class IndexAnimations extends Base {
    constructor() {
        super({el: Selectors.el});
    }
}
